import { ethers } from "ethers";
import tokenAbi from '../contractAbi/token.json'
import store from '@/store'
import wallet from "../wallet"
const BSC_CONFIG = wallet.BSC_CONFIG
const CURRENT_NETWORK = wallet.CURRENT_NETWORK
const RPC = BSC_CONFIG[CURRENT_NETWORK].rpcUrl

export async function balance(tokenAddress) {
  const provider = new ethers.providers.JsonRpcProvider(RPC)
  const address = store.state.walletAddress
  const TOKENContract = new ethers.Contract(tokenAddress, tokenAbi, provider);
  const tokenBalance = await TOKENContract.balanceOf(address);
  return ethers.utils.formatUnits(tokenBalance, 18)
}

export async function allowance(tokenAddress, contract_address) {
  const provider = new ethers.providers.JsonRpcProvider(RPC)
  const address = store.state.walletAddress
  const TOKENContract = new ethers.Contract(tokenAddress, tokenAbi, provider);
  const tokenAllowance = await TOKENContract.allowance(address, contract_address);
  return ethers.utils.formatUnits(tokenAllowance, 18)
}

export async function approve(tokenAddress,contract_address,amount) {
  const provider = new ethers.providers.Web3Provider(window.ethereum)
  const signer = provider.getSigner()
  const TOKENContract = new ethers.Contract(tokenAddress, tokenAbi, provider);
  const tokenSigner = TOKENContract.connect(signer)
  // console.log('parseUnits(amount)', parseUnits(amount.toString()))
  const tx = await tokenSigner.approve(contract_address, ethers.utils.parseUnits(amount.toString()))
  const waitRes = await tx.wait()
  return waitRes
}